import { useState } from "react";
import { Box, Button, Typography } from "@mui/material";

import useSecurity from "../../hooks/useSecurity";
import useLocalization from "../../hooks/useLocalization";

import Card from "../layout/Card";
import Input from "../elements/Input";

import logo from "../../assets/images/logo.png";

const Login = () => {
  const { login } = useSecurity();
  const { getLabel, getTitle, getMessage } = useLocalization();

  const [username, setUsername] = useState();
  const [password, setPassword] = useState();
  const [message, setMessage] = useState();

  const verifyCredentials = async () => {
    try {
      setMessage(null);
      const results = await login(username, password);
      if (results.isSuccessful) {
      } else {
        setMessage(results.message);
      }
    } catch (err) {}
  };

  return (
    <>
      <Box
        padding="20px"
        display="flex"
        flexDirection="column"
        alignItems="center"
        gap={2}
      >
        <img
          src={logo}
          width="150px"
          height="auto"
        />

        <Typography variant="h4">{getTitle("loginPageTitle")}</Typography>
      </Box>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Card width={300}>
          <>
            <Box
              display="flex"
              alignItems="center"
              flexDirection="column"
              gap={2}
            >
              <Typography variant="h5">{getTitle("credentials")}</Typography>
              <Input
                label={getLabel("Username")}
                value={username}
                onChange={(newValue) => setUsername(newValue)}
              />
              <Input
                label={getLabel("Password")}
                type="password"
                value={password}
                onChange={(newValue) => setPassword(newValue)}
              />
              <Button
                variant="contained"
                size="small"
                onClick={verifyCredentials}
              >
                Login
              </Button>
              <Typography>{getMessage(message)}</Typography>
            </Box>
          </>
        </Card>
      </Box>
    </>
  );
};

export default Login;
